export const URL_FORMAT =
  '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9а-яА-ЯёЁA-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Zа-яА-ЯёЁ]{2,6})+)(/(.)*)?(\\?(.)*)?';

export const BLOT_FORMAT =
  /(<span class="ql-editable-blot" type=")(\p{L}*)(" name=")?([\p{L}\p{N}\-.\s]*)?(" contenteditable="false">)(.*?)(<\/span>)/gu;
